/**
 * Glyphs for the employee bottom tab bar (`.wp-ess-tabbar`, App.tsx).
 *
 * Inline SVG rather than an icon dependency, matching the precedent in
 * `employee_top_bar.tsx` and `employee_locale_switcher.tsx`. Purely
 * decorative: each tab's visible label is its accessible name, so the glyphs
 * are `aria-hidden`. `currentColor` lets the tab's active/idle colour drive
 * the stroke.
 */

/** A payslip/card glyph for the "My pay" tab. */
export function EssPayTabIcon(): React.JSX.Element {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="1.8"
      strokeLinecap="round"
      strokeLinejoin="round"
      aria-hidden="true"
    >
      <rect x="3" y="6" width="18" height="13" rx="3" />
      <path d="M3 10h18M7 15h4" />
    </svg>
  );
}

/** A calendar-with-tick glyph for the "My leave" tab. */
export function EssLeaveTabIcon(): React.JSX.Element {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="1.8"
      strokeLinecap="round"
      strokeLinejoin="round"
      aria-hidden="true"
    >
      <rect x="3" y="5" width="18" height="16" rx="3" />
      <path d="M8 3v4M16 3v4M3 10h18M9 15l2 2 4-4" />
    </svg>
  );
}

/** A person glyph for the "Profile" tab. */
export function EssProfileTabIcon(): React.JSX.Element {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="1.8"
      strokeLinecap="round"
      strokeLinejoin="round"
      aria-hidden="true"
    >
      <circle cx="12" cy="8" r="4" />
      <path d="M4 21c0-4 3.6-7 8-7s8 3 8 7" />
    </svg>
  );
}
